import imagesJson from '@designwithfriends/common/images/images.json';

// The extension zip + version.json are published to the public assets bucket
// (designwithfriends-prod-assets) by the Ingestion Extension CI workflow; the
// same prod URL (the main distribution's /assets/* behaviour) serves both envs.
const EXTENSION_BASE_URL = `${imagesJson.assetsBaseUrl}/ingestion-extension`;

const DEV = {
    "catalogueServiceBaseUrl": "http://localhost:3000",
    "clientBaseUrl": "http://localhost:3003",
    "ingestionServiceBaseUrl": "http://localhost:3010/api",
    "geoExposureServiceBaseUrl": "http://localhost:3012/api",
    "extensionDownloadUrl": `${EXTENSION_BASE_URL}/ingestion-extension.zip`,
    "extensionVersionUrl": `${EXTENSION_BASE_URL}/version.json`,
};

const PROD = {
    // PR previews of the back-office are built pointing at the per-PR
    // catalogue preview when the PR deploys one (backoffice-preview.yml sets
    // the var); prod builds leave it unset.
    "catalogueServiceBaseUrl": process.env.REACT_APP_CATALOGUE_BASE_URL || "https://catalog-service.designwithfriends.com",
    // Previews point at the PR's client preview so the campaign preview iframe
    // draws the PR's renderer (backoffice-preview.yml sets the var).
    "clientBaseUrl": process.env.REACT_APP_CLIENT_BASE_URL || "https://designwithfriends.com",
    // PR previews of the back-office are built pointing at a per-PR ingestion
    // preview (backoffice-preview.yml sets the var); prod builds leave it unset.
    "ingestionServiceBaseUrl": process.env.REACT_APP_INGESTION_BASE_URL || "https://ingestion.designwithfriends.com/api",
    // The GEO exposure tool (packages/geo-exposure) has no per-PR previews.
    "geoExposureServiceBaseUrl": "https://geo-exposure.designwithfriends.com/api",
    "extensionDownloadUrl": `${EXTENSION_BASE_URL}/ingestion-extension.zip`,
    "extensionVersionUrl": `${EXTENSION_BASE_URL}/version.json`,
};

export const config = () => {
    switch (process.env.REACT_APP_STAGE) {
        case 'dev':
        case 'development':
            return DEV;
        case 'prod':
        case 'production':
            return PROD;
        default:
            return DEV;
    }
};